<template>
  <div>
    <breadcrumb-one banner_height="page-banner-height-2" title="Contact Us" subtitle="Contact Us"></breadcrumb-one>
    <div class="location-area pt-70 pb-25">
      <div class="container">
        <div class="row mb-25">
          <div class="col-xl-12">
            <div class="abs-section-title text-center"><span>LOCATION STORE</span>
              <h4>Where We Are</h4>
              <p>The perfect way to enjoy brewing tea on low hanging fruit to identify. Duis autem vel eum iriure dolor
                in hendrerit <br> in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla
                facilisis.</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-3 col-lg-3 col-md-6">
            <div class="location-item mb-30">
              <div class="location-image w-img mb-20"><img src="/images/location/location-1.jpg" alt="image"></div>
              <h6>26 Rue Pelleport - Paris</h6>
              <div class="sm-item-loc sm-item-border mb-20">
                <div class="sml-icon mr-20"><i class="fal fa-map-marker-alt"></i></div>
                <div class="sm-content"><span>Find us</span>
                  <p>Rue Saint-Antoine, Paris, France</p>
                </div>
              </div>
              <div class="sm-item-loc sm-item-border mb-20">
                <div class="sml-icon mr-20"><i class="fal fa-phone-alt"></i></div>
                <div class="sm-content"><span>Call us</span>
                  <p><a href="tel:+8804568">(+100) 123 456 7890</a></p>
                </div>
              </div>
              <div class="sm-item-loc mb-20">
                <div class="sml-icon mr-20"><i class="fal fa-envelope"></i></div>
                <div class="sm-content"><span>Mail us</span>
                  <p><a href="mailto:pKf9t@example.com">pKf9t@example.com</a></p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-6">
            <div class="location-item mb-30">
              <div class="location-image w-img mb-20"><img src="/images/location/location-2.jpg" alt="image"></div>
              <h6>150 Stanley Rd - London</h6>
              <div class="sm-item-loc sm-item-border mb-20">
                <div class="sml-icon mr-20"><i class="fal fa-map-marker-alt"></i></div>
                <div class="sm-content"><span>Find us</span>
                  <p>Brick Ln, Spitalfields, London E1, UK</p>
                </div>
              </div>
              <div class="sm-item-loc sm-item-border mb-20">
                <div class="sml-icon mr-20"><i class="fal fa-phone-alt"></i></div>
                <div class="sm-content"><span>Call us</span>
                  <p><a href="tel:+8804568">(+100) 123 456 7890</a></p>
                </div>
              </div>
              <div class="sm-item-loc mb-20">
                <div class="sml-icon mr-20"><i class="fal fa-envelope"></i></div>
                <div class="sm-content"><span>Mail us</span>
                  <p><a href="mailto:pKf9t@example.com">pKf9t@example.com</a></p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-6">
            <div class="location-item mb-30">
              <div class="location-image w-img mb-20"><img src="/images/location/location-3.jpg" alt="image"></div>
              <h6>1357 Prospect - New York</h6>
              <div class="sm-item-loc sm-item-border mb-20">
                <div class="sml-icon mr-20"><i class="fal fa-map-marker-alt"></i></div>
                <div class="sm-content"><span>Find us</span>
                  <p>Atlantic, Brooklyn, New York, US</p>
                </div>
              </div>
              <div class="sm-item-loc sm-item-border mb-20">
                <div class="sml-icon mr-20"><i class="fal fa-phone-alt"></i></div>
                <div class="sm-content"><span>Call us</span>
                  <p><a href="tel:+8804568">(+100) 123 456 7890</a></p>
                </div>
              </div>
              <div class="sm-item-loc mb-20">
                <div class="sml-icon mr-20"><i class="fal fa-envelope"></i></div>
                <div class="sm-content"><span>Mail us</span>
                  <p><a href="mailto:pKf9t@example.com">pKf9t@example.com</a></p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-6">
            <div class="location-item mb-30">
              <div class="location-image w-img mb-20"><img src="/images/location/location-4.jpg" alt="image"></div>
              <h6>86 Georgia Rd - Mardrid</h6>
              <div class="sm-item-loc sm-item-border mb-20">
                <div class="sml-icon mr-20"><i class="fal fa-map-marker-alt"></i></div>
                <div class="sm-content"><span>Find us</span>
                  <p>Calle del Correo, 4, Madrid, Spain</p>
                </div>
              </div>
              <div class="sm-item-loc sm-item-border mb-20">
                <div class="sml-icon mr-20"><i class="fal fa-phone-alt"></i></div>
                <div class="sm-content"><span>Call us</span>
                  <p><a href="tel:+8804568">(+100) 123 456 7890</a></p>
                </div>
              </div>
              <div class="sm-item-loc mb-20">
                <div class="sml-icon mr-20"><i class="fal fa-envelope"></i></div>
                <div class="sm-content"><span>Mail us</span>
                  <p><a href="mailto:pKf9t@example.com">pKf9t@example.com</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cmamps-area"><iframe
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1899531.5831083965!2d105.806381!3d21.58504!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x515f4860ede9e108!2zVHLGsOG7nW5nIMSQ4bqhaSBo4buNYyBDw7RuZyBuZ2jhu4cgVGjDtG5nIHRpbiB2w6AgVHJ1eeG7gW4gdGjDtG5n!5e0!3m2!1sen!2sus!4v1644226635446!5m2!1sen!2sus"></iframe>
    </div>
  </div>
</template>

<script>
import BreadcrumbOne from '@/components/breadcrumb/breadcrumb-one.vue'
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "About",
  components: {
    BreadcrumbOne,
  },
}
</script>

<style scoped>
/* Add styles for Home page */
</style>